<template>
  <div>
    <b-alert
      v-if="status"
      :show="status"
      :class="$style.saleBanner"
    >
      <div v-if="category">
        <router-link
          :class="$style.categoryLink"
          :to="{
            name: 'category-page',
            query: { categoryId: category.id, 'page[number]': 1 },
          }"
        >
          {{ banner.message }}
        </router-link>
      </div>
      <div v-else>
        {{ banner.message }}
      </div>
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      current: 'shopBanners/getCurrentBanner',
      scheduled: 'shopBanners/getScheduledBanner',
      status: 'shopBanners/getBannerStatus',
    }),
    banner() {
      return this.current || this.scheduled
    },
    category() {
      if (this.banner && this.banner.shopItemCategory) {
        return this.banner.shopItemCategory
      } else {
        return null
      }
    },
  },
}
</script>

<style lang="scss" module>
.categoryLink {
  text-decoration: none !important;
}
.closedBanner {
  padding: 29px 15px;
  color: #fff;
  text-align: center;
  background: var(--brandColor);
  border-color: var(--brandColor);
  border-radius: 0 !important;
}
.saleBanner {
  padding: 29px 15px;
  color: var(--brandColor);
  text-align: center;
  background: #f3f3f3;
  border-color: #f3f3f3;
}
</style>
